import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Adventureactivities() {



    const cardData =
    {
        keyword: 'Adventure Activities at Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Adventure Activities at Morachi Chincholi Pune',
        headingDescription: 'Looking for an exciting rural escape filled with fun? Anand Krushi Paryatan Kendra offers thrilling and engaging adventure activities at Morachi Chincholi Pune, just 55 km from the city. Set within a sprawling 40-acre agri-tourism farm, this destination is perfect for families, school groups, and corporate teams seeking outdoor adventure and fresh air. Guests can enjoy a wide range of adventure-packed experiences like bullock cart and tractor rides, horse riding, boating, and swimming. The rain dance area adds a splash of fun, while traditional village games challenge your reflexes and bring out your competitive spirit.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Rope Course Adventures",
    "description": "Test your balance and courage with rope bridges, Burma loops, hanging planks, and balancing logs set up across open fields and shady trees. These low-height adventure setups are safe for all age groups and packed with excitement."
  },
  {
    "title": "Wall Climbing & Tyre Crossing",
    "description": "Try your hand (and feet!) at vertical wall climbing or navigate swinging tyre tunnels. These activities build confidence, coordination, and are popular among kids, teens, and corporate teams during outdoor challenges."
  },
  {
    "title": "Zip Line & Monkey Crawls",
    "description": "Experience mild zip lining over short stretches—safe yet thrilling enough to feel the rush. Monkey crawls across nets or ropes give a true adventure park vibe in a rustic village setting."
  },
  {
    "title": "Tractor & Bullock Cart Off-Road Rides",
    "description": "Hop on a rugged tractor ride or a rhythmic bullock cart safari through dusty village trails and farm lanes. It's an authentic off-road adventure with a cultural twist—great for scenic views and group fun."
  },
  {
    "title": "Obstacle Course Challenge",
    "description": "Engage in team-based obstacle races with hurdles, rope nets, crawling sections, and balancing beams. Designed for schools and corporate groups, this activity promotes bonding, fitness, and laughter."
  },
  {
    "title": "Archery & Target Practice",
    "description": "Try your aim at archery and traditional slingshot target games using eco-safe setups. These light adventure games sharpen focus and are enjoyable for both kids and adults."
  },
  {
    "title": "Bamboo Balance & Log Walks",
    "description": "Walk across narrow bamboo beams or suspended logs. These mini-challenges build core strength and offer rustic village-style thrills in a controlled environment."
  },
  {
    "title": "Adventure Park for Kids",
    "description": "Dedicated adventure play zones for children include mini ziplines, tire swings, climbing ladders, and balance nets. Safety is a priority, with soft landings and supervisor assistance."
  },
  {
    "title": "Cycling Trails Around the Farm",
    "description": "Explore village paths and farmlands on bicycles available for rent. These offbeat cycling trails offer fresh air, open landscapes, and a mix of mud and gravel routes—great for casual riders and photography stops."
  },
  {
    "title": "Rain Dance With DJ Beats",
    "description": "After a full day of outdoor thrills, unwind with an energetic rain dance session under sprinklers, set to lively Marathi and Bollywood DJ music. It’s the perfect fun finale for any adventurous outing."
  }
],




  "services": [
    {
      "name": "Ziplining at Morachi Chincholi",
      "description": "Soar across mango orchards and scenic farmlands with our professionally supervised zipline setup. Perfect for thrill-seekers and photographers looking to capture dramatic aerial views."
    },
    {
      "name": "Rope Course Activities",
      "description": "Challenge your balance and agility on our rope courses featuring Burma bridges, tire walks, and rope ladders—ideal for team-building, fitness, and fun in an outdoor rural setting."
    },
    {
      "name": "Obstacle Challenges and Team Games",
      "description": "Engage in cooperative obstacle races, tire relay, sack races, and capture-the-flag style games designed to promote teamwork, communication, and energetic fun."
    },
    {
      "name": "Rock Climbing and Wall Activities",
      "description": "Test your strength on our outdoor rock-climbing wall—with different difficulty levels and harness support—great for beginners and adventure enthusiasts alike."
    },
    {
      "name": "Archery and Dart Games",
      "description": "Learn the ancient skill of archery or enjoy casual dart target games. Both experiences are supervised by trained staff and suitable for adults and older children."
    },
    {
      "name": "Bullock Cart Rides",
      "description": "Enjoy a traditional bullock cart ride through lush fields—an unhurried, authentic rural experience that’s fun for all ages and rich in local charm."
    },
    {
      "name": "Mud Games and Village Sports",
      "description": "Get messy with mud races, mud tug-of-war, and traditional village sports—fun, immersive, and perfect for groups seeking playful rural engagement."
    },
    {
      "name": "Guided Bird Watching and Nature Walk",
      "description": "Join early-morning guided walks led by naturalists to spot peacocks and native birds, while learning about local flora and eco-systems in Morachi Chincholi."
    },
    {
      "name": "Camping with Adventure Activities",
      "description": "Combine overnight camping with a day of adventure—ziplining, rope challenges, obstacle courses, and bonfires—creating a memorable rural adventure retreat."
    },
    {
      "name": "Outdoor Treasure Hunts",
      "description": "Solving clues across farm trails, team checkpoints, and cultural puzzles—our treasure hunts are engaging, strategic, and fun for all age groups."
    },
    {
      "name": "Rain Dance with Music",
      "description": "Celebrate under the rain dance setup accompanied by lively music—safe, supervised, and perfect for cooling down after adventure sessions."
    },
    {
      "name": "Bonfire + Adventure Combos",
      "description": "Cap off your adrenaline-filled day with a cozy evening bonfire, folk songs, snacks, and a relaxed atmosphere to unwind and bond as a group."
    },
    {
      "name": "Farm Games for Kids and Adults",
      "description": "From wheelbarrow races to pumpkin relays and rural batting games—our inclusive farm games bring active fun to all age groups in a rural outdoor environment."
    },
    {
      "name": "Adventure Group Packages",
      "description": "Packaged adventure experiences combining ziplining, climbing, team games, archery, and meals—with optional camping add-on for groups of friends, corporates, or institutes."
    },
    {
      "name": "Day Adventure Pass Options",
      "description": "Choose your own adventure with day passes that include access to all outdoor attractions—zipline, ropes, archery, obstacle zones, and bird walks—for a complete rural adventure experience."
    }
  ],
  "tableData": [
    ["Ziplining at Morachi Chincholi", "Rope Course Activities"],
    ["Obstacle Challenges and Team Games", "Rock Climbing and Wall Activities"],
    ["Archery and Dart Games", "Bullock Cart Rides"],
    ["Mud Games and Village Sports", "Guided Bird Watching and Nature Walk"],
    ["Camping with Adventure Activities", "Outdoor Treasure Hunts"],
    ["Rain Dance with Music", "Bonfire + Adventure Combos"],
    ["Farm Games for Kids and Adults", "Adventure Group Packages"],
    ["Day Adventure Pass Options", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Zip‑Lining Through the Groves",
    "WhyChoosedescription": "Feel the thrill of soaring over tamarind orchards on a zip‑line, offering both excitement and a bird’s‑eye view of Morachi Chincholi’s lush landscapes."
  },
  {
    "WhyChooseheading": "Archery and Target Sports",
    "WhyChoosedescription": "Test your focus and aim with archery sessions available at agro‑tourism centers, perfect for beginners and experienced enthusiasts alike."
  },
  {
    "WhyChooseheading": "Rope‑Climbing and Obstacle Course",
    "WhyChoosedescription": "Challenge yourself on rope‑climbing setups and obstacle courses that encourage teamwork, physical strength, and outdoor adventure."
  },
  {
    "WhyChooseheading": "Tractor Rides Across Farmlands",
    "WhyChoosedescription": "Experience the rugged charm of the countryside with tractor rides—great for groups looking for a laid‑back yet adventurous way to explore the region."
  },
  {
    "WhyChooseheading": "Rain‑Dance Zone & Splash Fun",
    "WhyChoosedescription": "Enjoy a refreshing rain‑dance area set to music, along with splash zones to cool off after thrilling activities—adds fun and relaxation for all ages."
  },
  {
    "WhyChooseheading": "Farm Pond Boating",
    "WhyChoosedescription": "Unwind with a calm boat ride in a tranquil farm pond—an ideal way to relax after high‑energy adventures and soak in the serene rural ambiance."
  }
]































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Are there adventure activities available at Morachi Chincholi?',
    answer: 'Yes, Morachi Chincholi offers a variety of adventure and outdoor activities ideal for families, friends, and corporate groups.',
  },
  {
    id: 'FAQ2',
    question: 'What are some popular adventure activities at Morachi Chincholi?',
    answer: 'Popular activities include bullock cart rides, tractor rides, ziplining (at select resorts), rope climbing, Burma bridge, and archery.',
  },
  {
    id: 'FAQ3',
    question: 'Are these activities safe for kids?',
    answer: 'Yes, most adventure activities are designed to be safe and are supervised by trained staff, making them suitable for children.',
  },
  {
    id: 'FAQ4',
    question: 'Can we participate in team-building adventure games?',
    answer: 'Yes, several resorts offer team-based challenges and games for corporate outings and group bonding activities.',
  },
  {
    id: 'FAQ5',
    question: 'Do I need to pay extra for adventure activities?',
    answer: 'Some activities are included in the day package, while others like ziplining or rope courses may require an additional fee.',
  },
  {
    id: 'FAQ6',
    question: 'What should I wear for adventure activities?',
    answer: 'Wear comfortable clothing, closed-toe shoes, and carry water, sunscreen, and a cap for outdoor protection.',
  },
  {
    id: 'FAQ7',
    question: 'Are these activities available year-round?',
    answer: 'Most activities are available throughout the year, though some may be affected during heavy rains in the monsoon season.',
  },
  {
    id: 'FAQ8',
    question: 'Can I book adventure activities in advance?',
    answer: 'Yes, it is recommended to inform the resort in advance if you want to include specific adventure activities in your visit.',
  },
  {
    id: 'FAQ9',
    question: 'Are the adventure zones inside the resorts?',
    answer: 'Yes, most activities are set up within the boundaries of agro-tourism resorts and are easily accessible to guests.',
  },
  {
    id: 'FAQ10',
    question: 'Is prior experience required for participating in these activities?',
    answer: 'No, most adventure activities are beginner-friendly and can be enjoyed by participants without prior experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amol Patankar, Pune',
    feedback: "We had a great time doing rope climbing and archery at Morachi Chincholi. A perfect blend of fun and rural adventure!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Satpute, PCMC',
    feedback: "The zipline and tractor ride were thrilling! It was a unique experience to enjoy adventure in a natural, village setup.",
    rating: 5,
  },
];

































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const adventureSchema = {
  "@context": "https://schema.org",
  "@type": "TouristAttraction",
  "name": "Adventure Activities at Morachi Chincholi Pune",
  "description": "Experience thrilling adventure activities at Morachi Chincholi Pune including ziplining, rope courses, rock climbing, archery, bullock cart rides, mud games, bird watching, camping, rain dance, bonfire combos, and family-friendly farm games.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Anand Krushi Paryatan Kendra",
    "sameAs": "https://morachichincholi.in/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Morachi Chincholi, Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/adventure-activities"
  }
};




    return (
        <div>
<Helmet>
  <title>Adventure Activities at Morachi Chincholi Pune | Ziplining, Rock Climbing & More</title>
  <meta 
    name="description" 
    content="Discover exciting adventure activities at Morachi Chincholi Pune. Enjoy ziplining, rock climbing, archery, mud games, bullock cart rides, bird watching, camping, rain dance, bonfire combos, and family-friendly farm games." 
  />
  <meta 
    name="keywords" 
    content="Ziplining at Morachi Chincholi, Rope course activities, Obstacle challenges and team games, Rock climbing and wall activities, Archery and dart games, Bullock cart rides, Mud games and village sports, Guided bird watching and nature walk, Camping with adventure activities, Outdoor treasure hunts, Rain dance with music, Bonfire + adventure combos, Farm games for kids and adults, Adventure group packages, Day adventure pass options" 
  />
  <script type="application/ld+json">
    {JSON.stringify(adventureSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Adventureactivities;